import {
  TeamColorSettings,
  TeamId,
  CALENDAR_ENTRY_TYPES,
  EventColorSetting,
  TeamStatKeys,
  AccountId,
  PlayerStatKeys
} from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function accountPrivate__client__updatePlayerTrendsStats(p: {
  accountId: AccountId;
  playerId: string;
  trendsSettings: { [key in PlayerStatKeys]?: true };
}) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  await h.AccountPrivate.setPath({
    id: p.accountId,
    pathObj: { settings: { playerTrendsStats: { [p.playerId]: true } } },
    value: { settings: { playerTrendsStats: { [p.playerId]: p.trendsSettings } } }
  });
}

// i18n certified - complete
